import React, { ReactElement, useEffect, useState } from 'react';
import { Button, IconRecordActive } from '@seismic/mantle';
import { IRecordingState, RecordingStateActions, WorkflowSteps } from '../../models';
import { IRecordingStateReducerAction } from '../../hooks';
import styles from '../Footer.scss';
import { useTranslation } from 'react-i18next';

interface FooterProps {
  state: IRecordingState;
  dispatch: React.Dispatch<IRecordingStateReducerAction>;
  onCancel: () => void;
}

export default function SetupFooter(props: FooterProps): ReactElement {
  const { t } = useTranslation();
  const { onCancel, state, dispatch } = props;
  const recorder = state.recorder;
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (recorder) {
      recorder.onRecorderChange = (isReady) => setIsReady(isReady);
    }
  }, [recorder]);

  function onStartRecording() {
    dispatch({ type: RecordingStateActions.ChangeStep, payload: WorkflowSteps.Recording });
  }

  return (
    <div className={styles.footer}>
      <Button
        label={t('Footer.Cancel', { defaultValue: 'Cancel' })}
        className={styles.cancelButton}
        data-testid="cancel-button"
        variant="tertiary"
        onClick={onCancel}
      />
      <Button
        label={t('Setup.Footer.Record', { defaultValue: 'Record' })}
        data-testid="start-recording-button"
        disabled={!isReady}
        startAdornment={IconRecordActive}
        variant="primary"
        onClick={onStartRecording}
      />
    </div>
  );
}
